import List from "@/components/list";

const Table = (args) => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function() {};

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
    },
    {
      label: "班组名称",
      prop: "groupName",
      minWidth: "180",
      showOverflowTooltip: true,
    },
  ];
  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
